import React from "react";
import WalletPage from "./WalletPage";

export default function Venmos() {
  return (
    <WalletPage
      type="venmo"
      title="Venmo"
      subtitle="Venmo accounts — name, balance, and status"
      prefix="venmo"
    />
  );
}
